import styled from 'styled-components';
const Font = styled.span `
    font-style: ${props => props.fontStyle ? props.fontStyle : 'normal'};
`;
export const Gilroy = styled(Font) `
    font-family: Gilroy, 'system-ui';
`;
export const Barlow = styled(Font) `
    font-family: Barlow, 'system-ui';
`;
// const Paragraph = styled.p<ParagraphProps>`
//     font-style: ${props => props.fontStyle ? props.fontStyle : 'normal'};
//     font-weight: ${props => props.fontWeight === 'semibold' ? 600 : 'normal'};
//     font-size: ${props => props.fontSize ? props.fontSize + 'px' : '1rem'};
//     color: ${props => props.fontColor ? props.fontColor : Blue.dark};
//     font-family: Barlow, 'system-ui';
// `;
export const Hero = styled.h1 `
    font-style: 'normal';
    font-weight: 800;
    font-size: 3.75rem;
    font-family: Gilroy, 'system-ui';
`;
export const H1 = styled(Hero) `
    font-size: 2.625rem;
`;
export const H2 = styled.h2 `
    font-size: 1.75rem;
    font-weight: bold;
    font-family: Gilroy, 'system-ui';
`;
export const H3 = styled.h3 `
    font-size: 1.5rem;
    font-weight: bold;
    font-family: Gilroy, 'system-ui';
`;
export const H4 = styled.h4 `
    font-size: 1.25rem;
    font-weight: bold;
    font-family: Gilroy, 'system-ui';
`;
export default {
    Hero,
    H1,
    H2,
    H3,
    H4,
};
//# sourceMappingURL=Font.styled.js.map